import styled, { css } from "styled-components";
import { bold as boldStyles, fonts, colors, easingSeconds } from ".";

const Link = styled.a`
    text-decoration: underline;
`;

const BaseText = styled.p`
    font-size: 0.875rem;
    ${props => props.bold && boldStyles};
`;

const HeaderSmall = styled.h3`
    font-size: 1rem;
    ${boldStyles};
`;

const textStyles = css`
    ${({ size }) =>
        size === "inherit" ? "font-size: inherit" : fonts.typeScale[size]};
    ${({ bold }) => (bold ? boldStyles : null)};
    color: ${({ color }) => (color ? color : "inherit")};
`;

const A = styled.a`
    ${textStyles};
    text-decoration: underline;
`;

/* use for text that looks like a link,
but doesn't actually take the user to a new page */
const ButtonLink = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    ${textStyles};
    text-decoration: underline;
`;

/* use for an anchor tag that has a border-bottom instead of an underline;
    style is exported in case we need to add it to a link.
    Exported the hover because we need only the hover state for some links
*/
export const BorderBottonLinkStylesHover = css`
    text-decoration: none;
    color: ${colors.dark};
    border-bottom: 1px solid ${colors.dark};
`;

export const BorderBottomLinkStyle = css`
    color: ${colors.brownishGrey};
    text-decoration: none;
    padding-bottom: 0.1875rem; /* 3px */
    border-bottom: 1px solid ${colors.brownishGrey};
    transition: all ${easingSeconds};

    &:hover {
        ${BorderBottonLinkStylesHover}
    }
`;

export const BorderBottomLink = styled.a`
    ${BorderBottomLinkStyle}
`;

const P = styled.p`
    ${textStyles};
`;

// use headings.js instead of these headings - we will deprecate these:
const H1 = styled.h1`
    ${textStyles};
`;

const H2 = styled.h2`
    ${textStyles};
`;

const H3 = styled.h3`
    ${textStyles};
`;

export {
    Link,
    BaseText,
    HeaderSmall,
    textStyles,
    A,
    P,
    H1,
    H2,
    H3,
    ButtonLink
};
